import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  template: `
    <div class="overlay" [class.active]="showOverlay"></div>
    <div class="error-dialog">
      <mat-icon class="alert-icon">warning</mat-icon>
      <h5><strong style="color: #000;">We're experiencing technical issues at the moment.</strong></h5>
      <p class="subtext" style="color: #000;">We apologize for any inconvenience caused.<br>Please try submitting again later.</p>
      <button mat-button color="primary" (click)="closeDialog()" class="ok-button">OK</button>
    </div>
  `,
  styles: [`
    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
      z-index: 999; /* Place the overlay behind the dialog */
      display: none; /* Initially hide the overlay */
    }
    
    .overlay.active {
      display: block; /* Show the overlay when active */
    }

    .error-dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      padding: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      z-index: 1000;
      text-align: center;
    }

    .alert-icon {
      color: orange;
      font-size: 36px;
      font-color: black;
      margin-right: 5px;
    }

    .alert-icon::after {
        color: black !important; /* Set the color of the exclamation mark to black */
      }

    .subtext {
      font-size: 12px;
      font-weight: bold;
    }

    .ok-button {
      padding: 5px 30px;
      background-color: #043C5A;
      color: white;
      border: none;
      box-shadow: none !important;
    }
  `],
})
export class ErrorDialogComponent {
  showOverlay: boolean = true; // Initially show the overlay

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string },
    private dialogRef: MatDialogRef<ErrorDialogComponent>
  ) {}

  closeDialog(): void {
    this.showOverlay = false; // Hide the overlay when dialog is closed
    this.dialogRef.close();
  }
}
